import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import Basket from '../../Assetes/Images/kfc-main-basket.svg'
import BucketCartItems from './BucketCartItems'
import { connect, useSelector } from 'react-redux';
import { priceunit } from '../../Components/client-config';
import _ from 'lodash';
import SpecialInstructions from './SpecialInstructions';
import { getProfile, handleSpecialInstruction, handleAlternateNumber } from '../../Redux';
import useTrackEvent from '../../hooks/useTrackHook';
import { toast } from 'react-toastify';
import jwtDecode from 'jwt-decode';
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';

function GusetCheckOut(props: any) {
    const cartData = useSelector((state: any) => state.cart.cartData);
    const cartQty = useSelector((state: any) => state.cart.cartQty);
    const orderType = useSelector((state: any) => state.payment.orderType);
    const deliveryfee = useSelector((state: any) => state.store.deliveryfee);
    const pos_fee = useSelector((state: any) => state.store.pos_fee);
    const storeSelected = useSelector((state: any) => state.store.storeSelected);
    const donationItems = useSelector((state: any) => state.cart.donationItems);
    const history = useHistory();
    const [isSticky, setIsSticky] = useState(true)
    const { validateStoreSpecification, clickNext } = props;
    const [addEvent] = useTrackEvent();
    const lang = useCurrentLocale();
    const { t } = useTranslation();

    
    useEffect(() => {
        window.onscroll = function (ev) {
            if ((window.innerHeight + window.scrollY + 350) >= document.body.offsetHeight) {
                setIsSticky(false)
            } else {
                setIsSticky(true)
            }
        };
    }, [])
    const handleCheckout = () => {
        addEvent({ category: "events", events: "Checkout Button" })
        let token = localStorage.getItem("userToken");
        if (sessionStorage.getItem("socialPhone")) {
            toast.error("Please update Profile Info");
            history.push(`/${lang}/my-details`);
            return;
        }
        if (!storeSelected) {
            toast.error(t("PLEASE_SELECT_ANY_STORE"))
            return;
        }
        if (clickNext) {
            let token = localStorage.getItem("userToken");
            if (token) {
                let windowObj = (window as any)
                windowObj.dataLayer.push({ ecommerce: null });
                windowObj.dataLayer.push({
                    'event': 'begin_checkout'
                });
                history.push(`/${lang}/payment-method`);
            } else {
                history.push(`/${lang}/details`);
            }
        } else {
            let windowObj = (window as any)
                windowObj.dataLayer.push({ ecommerce: null });
                windowObj.dataLayer.push({
                    'event': 'begin_checkout'
                });
            if (token) {
                let userData: any = jwtDecode(token);
                props.getProfile(userData.customer.customer_id, validateStoreSpecification,history)
            } else {
                validateStoreSpecification();
            }
        }
    }
    const calcTotal = (data: any) => {
        let sum: any = 0;
        data.forEach((item: any) => {
            sum += parseInt(item.totalItemPrice);
        });
        if (orderType == "Delivery") {
            if (!_.isEmpty(storeSelected)) {
                sum = pos_fee > 0 ? sum + deliveryfee + parseInt(pos_fee) : sum + deliveryfee;
            }
            else {
                sum = pos_fee > 0 ? sum + parseInt(pos_fee) : sum;
            }
        } else if (orderType == "Pickup") {
            sum = pos_fee > 0 ? sum + parseInt(pos_fee) : sum;
        }
        if(donationItems?.length > 0) {
            donationItems.map((item: any) => {
                sum += parseInt(item.totalItemPrice);
            })
        }
        let finalSum = sum;
        return Math.round(finalSum);
    };
    return (
        <>

            <div className="bucket-conainet-sticky">
                <div className='basket-items'>
                    <div className='item-add'>
                        {cartQty > 0 ?
                            <h3>{storeSelected ? cartQty : 0} {cartQty == 1 ? t("ITEMS") : t("ITEM")} {t("ADDED")}</h3>
                            :
                            <h3>{t("ORDER_DETAILS")}</h3>}
                        <div className='kfc-box-theme'>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    <div className='add-to-basket'>
                        {/* <img src={Basket} alt="" />
          <h4>Explore our menu to add some delicious items to your cart</h4> */}
                        <SpecialInstructions handleSpecialInstruction={props.handleSpecialInstruction} handleAternateNumber={props.handleAlternateNumber} />
                        <BucketCartItems />
                    </div>
                </div>

                <div onClick={() => (!clickNext && cartData.length > 0) ? handleCheckout() : null} className="kfc-card-price">
                    <div className='d-flex justify-content-between'>
                        <div className='d-flex align-items-center gap-10'>
                            <h6 className='font-normal mb-0'>{storeSelected ? cartQty : 0} {cartQty > 1 ? t("ITEMS") : t("ITEM")}</h6>
                            <h5 className='kfc-mmm'>| {storeSelected ? cartQty > 0 ? priceunit + calcTotal(cartData) : priceunit + 0 : priceunit + 0}</h5>

                        </div>
                        <div className='d-flex align-items-center'>
                            <h6 className='kfc-mmm px-2'>{clickNext ? t("LOADING") : t("CHECKOUT")}</h6>
                            <i className="ri-arrow-right-s-line errow-line web-errow"></i>
                        </div>
                    </div>
                </div>
            </div>

            <Link to="#" onClick={() => (!clickNext && cartData.length > 0) ? handleCheckout() : null}>
                <div className='mobile-cart' onClick={() => addEvent({ category: "events", events: "Checkout Button" })}>
                    <div className='d-flex justify-content-between align-items-baseline'>
                        <div className='d-flex align-items-center gap-10'>
                            <h6 className='font-normal mb-0'>{storeSelected ? cartQty : 0} {cartData.length > 1 ? t("ITEMS") : t("ITEM")}</h6>
                            <h5 className='kfc-mmm'>| {storeSelected ? cartQty > 0 ? priceunit + calcTotal(cartData) : priceunit + 0 : priceunit + 0}</h5>
                        </div>
                        <div className='d-flex align-items-center '>
                            <h6 className='kfc-mmm px-2'>{clickNext ? t("LOADING") : t("CHECKOUT")}</h6>
                            <i className="ri-arrow-right-s-line errow-line"></i>
                        </div>
                    </div>
                </div>
            </Link>
        </>
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleSpecialInstruction: (event: any) => {
            dispatch(handleSpecialInstruction(event));
        },
        handleAlternateNumber: (event: any) => {
            dispatch(handleAlternateNumber(event));
        },
        getProfile: (id: any, validateStoreSpecification: any,history:any) => {
            dispatch(getProfile(id, null, null,validateStoreSpecification,history));
        }
    };
};

export default connect(null, mapDispatchToProps)(GusetCheckOut);